import React from 'react';
// images
import heroImageDesktopWebp from './images/communities-hero-desktop.webp';
import heroImageMobileWebp from './images/communities-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => (
  <HeroSectionStyled
    sectionId='sustainability-impact-communities-hero'
    productName='Sustainability and impact'
    headingText='Investing in our communities.'
    descriptionText={<>Through philanthropy, volunteering, and strategic investments we&#39;re helping to create lasting community success.</>}
    ctaPrimary={{
      linkUrl: '/assets/pdf/sustainability/2024-sustainability-and-impact-report.pdf',
      buttonText: 'Read the report',
      ariaLabel: 'Read the sustainability and impact report.',
      isInternalPdf: true,
      children: '',
    }}
    backgroundImageAriaLabel='Children making creative drawing cards in the class room'
    backgroundImageDesktop={heroImageDesktopWebp.toString()}
    backgroundImageMobile={heroImageMobileWebp.toString()}
    backgroundImageDesktopLowRes={lowResImageDesktop}
    backgroundImageMobileLowRes={lowResImageMobile}
    backgroundVariant='lightB'
    themeType='lightTheme'
  />
);
